<!-- Filter Panel -->
<div class="filter-panel">
  <div class="filter-header">
    <div class="filter-title">
      <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
        />
      </svg>
      Dashboard Filters
    </div>
    <div class="filter-actions">
      <button [disabled]="!isFilterApplied()" class="clear-btn" (click)="clearFilter()">
        Clear All
      </button>
    </div>
  </div>

  <div class="filter-content">
    <div class="filter-row">
      <div class="filter-group date-range-group" [formGroup]="dateRange">
        <div class="filter-label">Filter by Date Range</div>
        <div class="date-range-single-wrapper">
          <app-date-range-picker
            formControlName="range"
            placeholder="Select duration"
            dropdownAlign="right"
          />
        </div>
      </div>

      @if (isAdmin()) {
        <div class="filter-group user-group">
          <div class="filter-label">Reseller</div>
          <div class="select-wrapper">
            <select
              class="user-select"
              [ngModel]="selectedResellerId() ?? ''"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="onUserSelect($event)"
            >
              <option value="">All Resellers</option>
              @for (user of userOptions(); track user._id) {
                <option [value]="user._id">{{ user.label }}</option>
              }
            </select>
            <svg class="select-chevron" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </div>
        </div>
      }

      @if (isAdmin() || isReseller()) {
        <div class="filter-group user-group">
          <div class="filter-label">Sub Reseller</div>
          <div class="select-wrapper">
            <select
              class="user-select"
              [ngModel]="selectedSubResellerId() ?? ''"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="onSubResellerSelect($event)"
            >
              <option value="">All Sub Resellers</option>
              @for (user of subResellerOptions(); track user._id) {
                <option [value]="user._id">{{ user.label }}</option>
              }
            </select>
            <svg class="select-chevron" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </div>
        </div>
      }
    </div>
  </div>
</div>

@if (!isLoading()) {
  <!-- Stats Grid -->
  <div class="stats-grid">
    <!-- Single Messages -->
    <div class="stat-card">
      <div class="stat-header">
        <div class="stat-card-title">Single Messages</div>
        <div class="stat-icon">
          <i class="fa-solid fa-comment-sms"></i>
        </div>
      </div>
      <div class="stat-value">{{ typeTotal(stats().single) }}</div>
      <div class="stat-description">Individual SMS messages</div>
      <div class="stat-status-breakdown">
        @for (field of statusFields; track field.key) {
          <div class="stat-status-item" [ngClass]="field.cssClass">
            <span class="stat-status-count">{{ stats().single[field.key] }}</span>
            <span class="stat-status-label">{{ field.label }}</span>
          </div>
        }
      </div>
    </div>

    <!-- Campaign Messages -->
    <div class="stat-card">
      <div class="stat-header">
        <div class="stat-card-title">Campaign Messages</div>
        <div class="stat-icon">
          <i class="fa-solid fa-bullhorn"></i>
        </div>
      </div>
      <div class="stat-value">{{ typeTotal(stats().campaign) }}</div>
      <div class="stat-description">
        @if (stats().totalCampaign > 0) {
          {{ stats().totalCampaign }} campaigns · message breakdown below
        } @else {
          Bulk campaign messages
        }
      </div>
      <div class="stat-status-breakdown">
        @for (field of statusFields; track field.key) {
          <div class="stat-status-item" [ngClass]="field.cssClass">
            <span class="stat-status-count">{{ stats().campaign[field.key] }}</span>
            <span class="stat-status-label">{{ field.label }}</span>
          </div>
        }
      </div>
    </div>
  </div>

  <!-- Status chart -->
  <div class="charts-grid">
    <div class="chart-card">
      <div class="chart-card-head">
        <div>
          <h2 class="chart-title">Status By Type</h2>
          <p class="chart-subtitle">Message status breakdown for single and campaign types</p>
        </div>
        <div class="chart-legend chart-legend--status">
          @for (field of chartLegendFields; track field.key) {
            <span class="legend-item">
              <span class="legend-dot" [ngClass]="field.cssClass"></span>
              {{ field.label }}
            </span>
          }
        </div>
      </div>

      <div class="status-chart">
        @for (row of statusChartRows(); track row.label) {
          @let bucket = row.stats;
          @let total = statusChartTotal(bucket);
          <div class="status-chart-row">
            <div class="status-chart-row-head">
              <span class="status-chart-label">{{ row.label }}</span>
              <span class="status-chart-total">{{ total }}</span>
            </div>
            <div class="status-stacked-bar" [attr.aria-label]="row.label + ' status breakdown'">
              @for (field of chartStackFields(bucket); track field.key) {
                @if (bucket[field.key]) {
                  <span
                    class="status-segment"
                    [ngClass]="field.cssClass"
                    [style.width.%]="statusSegmentWidth(bucket[field.key], bucket)"
                    [attr.title]="field.label + ' ' + bucket[field.key]"
                  ></span>
                }
              }
            </div>
          </div>
        }
      </div>
      <p class="chart-footnote">Based on the date range and user filters applied above.</p>
    </div>
  </div>
}

@if (isLoading()) {
  <app-loader />
}
